exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notification {\n  margin-right: 7px;\n  margin-left: 7px;\n  float: right;\n  background: red;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  border-radius: .30em;\n  vertical-align: baseline; }\n\n.tabs {\n  border-right: 1px solid;\n  border-top-left-radius: .40rem;\n  border-top-right-radius: .40rem;\n  text-decoration: none;\n  display: inline-block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/providers-billing/denials/denials.component.scss
// module id = 2068
// module chunks = 66